import {
  LicenseModel,
  TenantBasicDetailModel,
  TenantBasicModel,
  TenantModel,
  TenantWithLicenses,
} from "../../pages/SuperAdminPages/Tenants/TenantModel";
const API_URL = `${process.env.REACT_APP_API_URL}`;
// const API_URL = process.env.REACT_APP_API_URL;

export const GetAllTenant = async (
  accessToken: string
): Promise<TenantModel[]> => {
  try {
    const response = await fetch(`${API_URL}/api/SuperAdmin/GetAllTenant`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch Tenants.");
    }

    const data = await response.json();
    console.log("Data of Get All", data);
    console.log("Tenant Data : ", data.map(mapToTenantModel));
    return data.map(mapToTenantModel);
  } catch (error) {
    throw error;
  }
};

export const CreateTenantBasicDetail = async (
  Tenant: TenantBasicDetailModel,
  accessToken: string
) => {
  try {
    const response = await fetch(`${API_URL}/api/SuperAdmin/CreateTenant`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(Tenant),
    });
    if (!response.ok) {
      throw new Error("Failed to add user.");
    }
    // Check if the response is JSON or plain text
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json(); // Parse JSON if content-type is JSON
    } else {
      return response.text(); // Parse as plain text otherwise
    }
  } catch (error) {
    throw error;
  }
};

export const UpdateTenantLicense = async (
  Tenant: LicenseModel,
  accessToken: string
) => {
  try {
    const response = await fetch(`${API_URL}/api/SuperAdmin/UpdateTenant`, {
      method: "POST", // Use PUT if your API expects it for updates
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(Tenant),
    });
    if (!response.ok) {
      throw new Error("Failed to update user.");
    }
    // Check if the response is JSON or plain text
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json(); // Parse JSON if the content type is JSON
    } else {
      return response.text(); // Parse plain text otherwise
    }
  } catch (error) {
    throw error;
  }
};

export const UpdateTenantBasicDetail = async (
  Tenant: TenantBasicDetailModel,
  accessToken: string
) => {
  try {
    const response = await fetch(`${API_URL}/api/SuperAdmin/UpdateTenant`, {
      method: "POST", // Use PUT if your API expects it for updates
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(Tenant),
    });
    if (!response.ok) {
      throw new Error("Failed to update user.");
    }
    // Check if the response is JSON or plain text
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json(); // Parse JSON if the content type is JSON
    } else {
      return response.text(); // Parse plain text otherwise
    }
  } catch (error) {
    throw error;
  }
};

export const DeleteTenant = async (
  TenantId: any,
  LicenseType: number,
  accessToken: string
) => {
  try {
    
    const apiUrl = `${API_URL}/api/SuperAdmin/DeleteTenant?tenandId=${encodeURIComponent(
      TenantId
    )}&licenseType=${LicenseType}`;
    console.log("Deleting User with Email:", TenantId, "URL:", apiUrl);
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error("Failed to delete user.");
    }
    return await response.text(); // Return plain text or success message
  } catch (error) {
    throw error;
  }
};

export const GetTenantDetailById = async (
  TenantId: number,
  accessToken: string
) => {
  try {
    const apiUrl = `${API_URL}/api/SuperAdmin/GetTenantDetailById?tenantId=${encodeURIComponent(
      TenantId
    )}`;
    console.log("Getting Tenant with Id:", TenantId, "URL:", apiUrl);
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to Get user.");
    }

    const data = await response.json();
    console.log("Without Map Data:", data);

    // 🛠 Handle array
    const tenant = Array.isArray(data) ? data[0] : data;

    console.log("Tenant Data Mapped:", mapToTenantModelWithLicense(tenant));
    return mapToTenantModelWithLicense(tenant);
  } catch (error) {
    throw error;
  }
};


export const CreateTenantLicense = async (
  Tenant: LicenseModel,
  accessToken: string
) => {
  try {
    const response = await fetch(`${API_URL}/api/SuperAdmin/CreateTenantLicense`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(Tenant),
    });
    if (!response.ok) {
      throw new Error("Failed to add user.");
    }
    // Check if the response is JSON or plain text
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json(); // Parse JSON if content-type is JSON
    } else {
      return response.text(); // Parse as plain text otherwise
    }
  } catch (error) {
    throw error;
  }
};


// CreateTenantLicense

export const mapToTenantModel = (data: any): TenantModel => {
  return {
    Id: data.id,
    TenantID: data.tenantID || "",
    Name: data.name || "",
    Description: data.description || "",
    PhoneNumber: data.phoneNumber || "",
    Email: data.email || "",
    Address: data.address || "",
    IsActive: data.isActive || false,
    LicenseType: data.licenseType || 0,
    NoOfUsers: data.noOfUsers || 0,
    LicenseStartDate: data.licenseStartDate
      ? new Date(data.licenseStartDate)
      : new Date(),
    LicenseEndDate: data.licenseEndDate
      ? new Date(data.licenseEndDate)
      : new Date(),
    MaxLimitPerDay: data.maxLimitPerDay || 0,
    MaxSize: data.maxSize || 0,
    TenantLicenseID: data.tenantLicenseID,
    MaxTokenPerMonth: data.maxTokenPerMonth,
  };
};

export const mapToTenantModelWithLicense = (data: any): TenantBasicModel => {
  return {
    Id: data.id,
    TenantID: data.tenantID || "",
    Name: data.name || "",
    Description: data.description || "",
    PhoneNumber: data.phoneNumber || "",
    Email: data.email || "",
    Address: data.address || "",
    IsActive: data.isActive || false,
    IsTrial: data.isTrial ?? false,
    DailyProcessLimitPerUser: data.dailyProcessLimitPerUser ?? 10,
    TeamAppId: data.teamAppID,
    Licenses: (data.licenses || []).map((license: any) => ({
      LicenseType: license.licenseType || 0,
      NoOfUsers: license.noOfUsers || 0,
      LicenseStartDate: license.licenseStartDate
        ? new Date(license.licenseStartDate)
        : new Date(),
      LicenseEndDate: license.licenseEndDate
        ? new Date(license.licenseEndDate)
        : new Date(),
      TenantLicenseID: license.tenantLicenseID || 0,
      MaxTokenPerMonth: license.maxTokenPerMonth ?? null,
      LMAndBotTokens: license.lmAndBotTokens ?? null,
      assignedLicenses: license.assignedLicenses,
      availableLicenses: license.availableLicenses,
      isLicenseActive: license.isLicenseActive,
      title: license.title
    })),
  };
};


export interface TenantLicenseTokenHistoryModel {
  HistoryID?: number;
  TenantLicenseID?: number;
  OldMaxTokenPerMonth: number;
  NewMaxTokenPerMonth: number;
  IsOpenAI: boolean;
  CreatedAt: string;
  CreatedBy?: number;
}

// Add this to your TenantService.ts or similar file
export const GetTenantLicenseTokenHistory = async (
  accessToken: string,
  tenantLicenseId: number
): Promise<TenantLicenseTokenHistoryModel[]> => {
  try {
    const url = `${API_URL}/api/SuperAdmin/GetTenantLicenseTokenHistory?tenantLiecenceId=${tenantLicenseId}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch token history.");
    }

    // return await response.json();

    const data = await response.json();
    console.log("Tenant License Token History : ", data.map(mapToTenantModel));
    return data.map(mapToTenantTokenHistory);
  } catch (error) {
    throw error;
  }
};
export const mapToTenantTokenHistory = (data: any): TenantLicenseTokenHistoryModel => {
  return {
    OldMaxTokenPerMonth: data.oldMaxTokenPerMonth,
    NewMaxTokenPerMonth: data.newMaxTokenPerMonth,
    IsOpenAI: data.isOpenAI,
    HistoryID: data.historyID,
    CreatedAt: data.createdAt
  };
};

export const CreateTenantLicenseTokenHistory = async (
  historyData: TenantLicenseTokenHistoryModel,
  accessToken: string
): Promise<any> => {
  try {
    const response = await fetch(
      `${API_URL}/api/SuperAdmin/CreateTenantLicenseTokenHistory`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(historyData),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to create token history record.");
    }

    return await response.text();
  } catch (error) {
    console.error("Error creating token history:", error);
    throw error;
  }
};